var map = {
	".": 78,
	"./": 78,
	"./assets/backward.png": 843,
	"./assets/bg.png": 301,
	"./assets/button_circulation.png": 844,
	"./assets/button_next.png": 845,
	"./assets/button_original.png": 846,
	"./assets/button_play.png": 847,
	"./assets/button_pre.png": 848,
	"./assets/button_translation.png": 849,
	"./assets/forward.png": 850,
	"./assets/select.png": 302,
	"./assets/select_loading.gif": 303,
	"./assets/sentence.png": 300,
	"./assets/welcome.png": 169,
	"./index": 78,
	"./index.js": 78,
	"./styles": 168,
	"./styles.js": 168
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 842;


//////////////////
// WEBPACK FOOTER
// ./src/components/listen/content ^.*$
// module id = 842
// module chunks = 0